import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { API } from "../../../../API";
import DetailsHolder from '../DetailsHolder'
import MyCalendar from '../../../College/Calendar/toast.ui.js'

import { getRulesFlag } from '../../../../Helper/BookingHelper'
import moment from 'moment/moment';

const CollegeDetailCalendar = ({ college, simpleQualifications }) => {

  const [allBookings, setAllBookings] = useState([])
  let [startDate, setStartDate] = useState(moment(new Date()).startOf("month").add(-1, 'days').startOf("month").format("YYYY-MM-DD"))
  let [endDate, setEndDate] = useState(moment(new Date()).endOf("month").add(1, 'days').endOf("month").format("YYYY-MM-DD"))
  const [isLoadCalendar, setIsLoadCalendar] = useState(true)
  const [loadedMonth, setLoadedMonth] = useState([])
  const [simpleQualificationList, setSimpleQualifications] = useState([])

  const isMonthLoaded = (year, month) => {
    return loadedMonth.includes(`${year}-${month}`);
  }

  const loadRangeOfMonths = (startDate, endDate) => {
    // Convert the start and end dates to Moment objects
    const startMoment = moment(startDate);
    const endMoment = moment(endDate);
    const loadedMonths = [];
    // Loop through each month in the range and load the data if it hasn't been loaded before
    let currentMoment = startMoment.clone();
    while (currentMoment <= endMoment) {
      const year = currentMoment.year();
      const month = currentMoment.month() + 1; // add 1 to convert from 0-indexed to 1-indexed
      if (!isMonthLoaded(year, month)) {
        loadedMonths.push(`${year}-${month}`);
      }
      currentMoment = currentMoment.add(1, 'months');
    }

    return loadedMonths;
  }

  useEffect(() => {
    if(isLoadCalendar) {
      //set date when create bookings in calendar
      const calendarDate = window.localStorage.getItem("calendarDate")
      if (moment(calendarDate, "YYYY-MM-DD", true).isValid()) {
        startDate = moment(calendarDate).startOf("month").add(-1, 'days').startOf("month").format("YYYY-MM-DD");
        endDate = moment(calendarDate).endOf("month").add(1, 'days').endOf("month").format("YYYY-MM-DD");
        window.localStorage.setItem("calendarDate", null)
      }
      const listMonth = loadRangeOfMonths(startDate, endDate)
      setLoadedMonth(month => ([...month, ...listMonth]))
      setIsLoadCalendar(false)
      API.getCampusBookingsByInstitutionIDPaginationV2(college.institution._id, startDate, endDate)
      .then((result) => {
        let list = result.data.data
          setAllBookings( preState => ([...preState, ...list]))
      })
      .catch((err) => {
        setIsLoadCalendar(false)
        console.log(err)
      })
    }
  }, [isLoadCalendar])

  useEffect(() => {
    // check simpleQualification list
    if(!simpleQualifications?.length) {
      API.getSimpleQualification().then(res => {
        setSimpleQualifications(res?.data?.data)
      })
    }
  }, [])

  const isSelect = (time, date) => {
    return getRulesFlag(college.user, time, date)
  }

  return (
    <DetailsHolder college={college} activePath='/CollegeDetailCalendar'>
      <MyCalendar
        user={college.user}
        institution={college.institution}
        campuses={college.campuses}
        classes={college.classes}
        teacher={{}}
        isSelect={isSelect}
        bookings={allBookings}
        newBookingProps={{}}
        isViewAsAdmin
        setStartDate={setStartDate}
        setEndDate={setEndDate}
        setIsLoadCalendar={setIsLoadCalendar}
        loadedMonth={loadedMonth}
        simpleQualifications={simpleQualifications?.length ? simpleQualifications : simpleQualificationList}
      ></MyCalendar>
    </DetailsHolder>
  )
}

function mapStateToProps(state) {
  return {
    college: state.admin.college_details,
    simpleQualifications: state.user.simpleQualifications
  }
}

export default connect(mapStateToProps)(CollegeDetailCalendar)
